import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=2e509f83&scoped=true&"
import script from "./ProductsFilter.vue?vue&type=script&lang=js&"
export * from "./ProductsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFilter.vue?vue&type=style&index=0&id=2e509f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e509f83",
  null
  
)

export default component.exports